<div class="responsive-card flex-column" [formGroup]="formGroup" [style.gap.rem]="!!spousalWaiver.attachment ? 1.5 : 1">
  <span class="title-md" i18n>
    {{ spousalWaiver.governingJurisdictionId | governingJurisdictionName }} Spousal Waiver
  </span>
  <div class="d-flex flex-column gap-4" *ngIf="!!spousalWaiver.attachment; else empty">
    <app-file-list-item
      [fileLabel]="waiverTypeId | spousalWaiverTypeLabel"
      [fileName]="spousalWaiver.attachment.fileName"
      [fileSizeInBytes]="spousalWaiver.attachment.fileSize"
      [previewUrl]="spousalWaiver.attachment.links | attachmentLink"
      action="download" />
    <div class="review-entry-grid" *ngIf="createdInPortalTypeId === PortalTypeIdEnum.Internal">
      <app-review-entry label="Date Signed" i18n-label [value]="spousalWaiver.signedDate | date : 'MMM d, yyyy'" />
      <app-review-entry
        label="Effective Date"
        i18n-label
        [value]="spousalWaiver.effectiveDate | date : 'MMM d, yyyy'" />
    </div>

    <div class="review-entry-grid" *ngIf="createdInPortalTypeId === PortalTypeIdEnum.Member">
      <div class="d-flex flex-column gap-2 flex-fill">
        <label [for]="'spousalWaiverDateSigned-' + spousalWaiver.id" class="form-input-label" i18n>Date Signed</label>
        <app-datepicker-input
          formControlName="spousalWaiverDateSigned"
          [controlId]="'spousalWaiverDateSigned-' + spousalWaiver.id"
          [error]="(formSubmitted || submissionStatusChanged) && formGroup.controls.spousalWaiverDateSigned.invalid" />
        <app-form-error
          *ngIf="(formSubmitted || submissionStatusChanged) && formGroup.controls.spousalWaiverDateSigned.invalid"
          [customErrorMessages]="customErrorMessages.spousalWaiverDateSigned"
          [errors]="formGroup.controls.spousalWaiverDateSigned.errors" />
      </div>
      <div class="d-flex flex-column gap-2 flex-fill">
        <label [for]="'spousalWaiverEffectiveDate-' + spousalWaiver.id" class="form-input-label" i18n
          >Effective Date</label
        >
        <app-datepicker-input
          formControlName="spousalWaiverEffectiveDate"
          [controlId]="'spousalWaiverEffectiveDate-' + spousalWaiver.id"
          [error]="
            (formSubmitted || submissionStatusChanged) && formGroup.controls.spousalWaiverEffectiveDate.invalid
          " />
        <app-form-error
          *ngIf="(formSubmitted || submissionStatusChanged) && formGroup.controls.spousalWaiverEffectiveDate.invalid"
          [customErrorMessages]="customErrorMessages.spousalWaiverEffectiveDate"
          [errors]="formGroup.controls.spousalWaiverEffectiveDate.errors" />
      </div>
    </div>

    <div
      class="d-flex justify-content-end gap-3 mt-2"
      *ngIf="createdInPortalTypeId === PortalTypeIdEnum.Member && (hasPendingChanges$ | async)">
      <app-button [type]="ButtonTypeEnum.secondary" [disabled]="isLoading" (buttonClick)="cancel()" i18n>
        Cancel
      </app-button>
      <app-button [type]="ButtonTypeEnum.primary" [loading]="isLoading" (buttonClick)="save()" i18n>Save</app-button>
    </div>
  </div>
</div>

<ng-template #empty>
  <div class="empty">
    <ng-container i18n *ngIf="createdInPortalTypeId === PortalTypeIdEnum.Member">
      A spousal waiver wasn’t included in the submission. The member will provide the form by mail, email or fax
      instead.
    </ng-container>
    <ng-container i18n *ngIf="createdInPortalTypeId === PortalTypeIdEnum.Internal">
      A spousal waiver wasn’t included in the submission.
    </ng-container>
  </div>
</ng-template>
